import Requests from '@/helpers/Request';

// Dunkler, einfarbiger Standard fuer die Cast-Seite, solange das Portal kein
// castBgColor liefert.
export const CAST_BG_DEFAULT = '#141414';
export const CAST_TEXT_DEFAULT = '#f1f1f1';

export default {
  namespaced: true,
  state: () => ({
    headline: '',
    color: '',
    headlineColor: '',
    headlineTextColor: '',
    roomTextColor: '',
    roomnameLeft: '52vw',
    roomnameTop: '20vh',
    buildingTextColor: '',
    buildingnameLeft: '52vw',
    buildingnameTop: '30vh',
    bgColor: '',
    dateBgColor: '',
    dateTextColor: '',
    dateBorderColor: '',
    activeAppBorderColor: '',
    activeAppTitleColor: '',
    activeAppBgColor: '',
    appBorderColor: 'transparent',
    appBarColor: '',
    appBarTextColor: '',
    appBgColor: '',
    appSubtitleColor: '',
    appBarIconColor: '',
    appBarHeight: '20',
    appBarBottom: '5',
    // Neue, optionale Felder fuer Inline-SVG-Kacheln (fill=currentColor).
    // Nur wenn mindestens eines gesetzt ist, wird der Inline-Modus aktiv;
    // sonst bleibt das komplette Verhalten wie bisher (Bestandsschutz).
    appIconColor: '',
    activeAppIconColor: '',
    activeLangColor: '',
    activeLangBorderColor: '',
    activeLangBgColor: 'transparent',
    langColor: '',
    langBorderColor: 'transparent',
    langBgColor: 'transparent',
    vodBgColor: '',
    vodFooterBorderColor: '',
    vodButtonColor: '',
    vodBorderColor: '',
    vodTextColor: '',
    vodListTextColor: '',
    bgImageVodUrl: '',
    isShowVodBackgroundImage: true,
    activeVodButtonColor: '',
    // Hintergrund der Cast-Seite. Bewusst EINFARBIG und ohne Bild: dort
    // stehen QR-Code, WLAN-Name und Passwort, die aus Sitzabstand lesbar sein
    // muessen - ein Foto dahinter stoert. Kommt wie alle Felder aus
    // /bid/<id>/customizer; leer = CAST_BG_DEFAULT.
    castBgColor: '',
    // Textfarbe der Kopfzeile auf der Cast-Seite. Eigene Farbe statt
    // headlineTextColor: die gehoert zum Startseiten-Hintergrund und kann auf
    // dem dunklen Cast-Hintergrund unlesbar sein. Leer = CAST_TEXT_DEFAULT.
    castTextColor: '',
    SVGAppColor: '',
    isShowHeadline: false,
    isShowBackgroundImage: true,
    isShowRoom: true,
    isShowRoomHeader: false,
    isShowBuilding: true,
    isShowDate: true,
    isShowDateBorder: false,
    bgImageUrl: '',
    bgImageWelcomeUrl: '',
    welcomeMessageColor: '',
    welcomeDetailColor: '',
    welcomeDetailActiveColor: '',
    welcomeDetailActiveBackgroundColor: '',
    welcomeCustomerNameColor: '',
    welcomeTextColor: '',
    welcomeLang: null,
    buildingId: '',
    id: '',
    language: {
      en: {
          "show" : true,
          "position" : 1
      },
      de: {
          "show" : true,
          "position" : 2
      },
      ch_de: {
          "show" : true,
          "position" : 3
      },
      ch_fr: {
          "show" : true,
          "position" : 4
      },
      ch_it: {
          "show" : true,
          "position" : 5
      },
      fr: {
          "show" : true,
          "position" : 6
      },
      it: {
          "show" : true,
          "position" : 7
      },
      es: {
          "show" : true,
          "position" : 8
      },
      ru: {
          "show" : true,
          "position" : 9
      },
      tr: {
          "show" : true,
          "position" : 10
      },
      ar: {
          "show" : false,
          "position" : 11
      },
      nl: {
          "show" : false,
          "position" : 12
      },
      ko: {
          "show" : false,
          "position" : 13
      },
      el: {
          "show" : false,
          "position" : 14
      },
      pt: {
          "show" : false,
          "position" : 15
      },
      hu: {
          "show" : false,
          "position" : 16
      },
      da: {
          "show" : false,
          "position" : 17
      },
      sv: {
          "show" : false,
          "position" : 18
      }
    }
  }),
  mutations: {
    setCustomizerValues(state, context) {
      for (const item in context) {
        state[item] = context[item];
      }
    },
  },
  actions: {
    async fetchCustomizerSettings({ commit, rootState }) {
      try {
        const response = await Requests.get(
          `${process.env.API_PORTAL}/bid/${rootState.buildingId}/customizer`
        );
        commit('setCustomizerValues', response[0]);
        return Promise.resolve();
      } catch (err) {
        console.log('Error in fetchCustomiyerSettings', err);
        return Promise.resolve();
      }
    },
  },
  getters: {
    getHomeBackground(state) {
      if (state.isShowBackgroundImage && state.bgImageUrl) {
        return `url(${state.bgImageUrl}) top left / cover no-repeat`;
      }
      return state.bgColor;
    },
    getVodBackground(state) {
      if (state.isShowVodBackgroundImage && state.bgImageVodUrl) {
        return `url(${state.bgImageVodUrl}) top left / cover no-repeat`;
      }
      return state.vodBgColor;
    },
    // Nur eine Farbe, kein Bild - auch dann nicht, wenn bgImageUrl gesetzt ist.
    // 'backgroundColor' statt 'background', damit ein versehentlich als Wert
    // geschicktes url(...) nicht doch ein Bild einschleust.
    getCastStyles(state) {
      const color = String(state.castBgColor || '').trim();
      return {
        backgroundColor: color || CAST_BG_DEFAULT,
        backgroundImage: 'none',
      };
    },
    getCastHeaderStyles(state) {
      const color = String(state.castTextColor || '').trim();
      return { color: color || CAST_TEXT_DEFAULT };
    },
    getHomeStyles(state, getters) {
      return {
        background: getters.getHomeBackground,
      };
    },
    getLanguages(state, getters) {
      return state.language;
    },
    getHeadlineTextStyles(state, getters) {
      var style = {};
      if(state.isShowHeadline) {
        style = {
          color: state.headlineTextColor,
          backgroundColor: state.headlineColor,
        };
      } else {
        style = {
          color: state.headlineTextColor,
          backgroundColor: 'transparent',
          height: '10vh',
          fontSize: '4vh',
        };
      }
      return style;
    },
    getLangImgStyle(state, getters) {
      var style = {};
      if(state.isShowHeadline) {
        style = {};
      } else {
        style = {
          marginRight: '1.5vh',
          maxHeight: '3.5vh',
        };
      }
      return style;
    },
    getLangStyle: (state) => (isActive) => {
    //getLangStyle (state, getters) {
      var style = {};
      //if(state.isShowHeadline) {
      //console.log("===========================================================getLangStyle", isActive);
      if (isActive) {
        style = {
          color: state.activeLangColor,
          borderColor: state.activeLangBorderColor,
          //border: '0.3vh solid #010101',
          borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.activeLangBgColor,
        };
      } else {
        style = {
          color: state.langColor,
          borderColor: state.langBorderColor,
          //border: '0.3vh solid #010101',
          borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.langBgColor,
        };
      }
      return style;
    },
    getBackStyle: (state) => (isActive) => {
    //getLangStyle (state, getters) {
      var style = {};
      //if(state.isShowHeadline) {
      //console.log("===========================================================getLangStyle", isActive);
      if (isActive) {
        style = {
          color: state.activeLangColor,
          borderColor: state.activeLangBorderColor,
          //border: '0.3vh solid #010101',
          //borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.activeLangBgColor,
        };
      } else {
        style = {
          color: state.langColor,
          borderColor: state.langBorderColor,
          //border: '0.3vh solid #010101',
          //borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.langBgColor,
        };
      }
      return style;
    },
    getBackStyleVod: (state) => (isActive) => {
    //getLangStyle (state, getters) {
      var style = {};
      //if(state.isShowHeadline) {
      //console.log("===========================================================getLangStyle", isActive);
      if (isActive) {
        style = {
          color: state.activeLangColor,
          borderColor: state.activeLangBorderColor,
          //border: '0.3vh solid #010101',
          //borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.activeLangBgColor,
        };
      } else {
        style = {
          color: state.langColor,
          borderColor: state.langBorderColor,
          //border: '0.3vh solid #010101',
          //borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.langBgColor,
        };
      }
      return style;
    },
    getHotelnameTextStyles(state, getters) {
      return {
        color: state.buildingTextColor,
        left: state.buildingnameLeft,
        top: state.buildingnameTop
      };
    },
    getRoomnameTextStyles(state, getters) {
      return {
        color: state.roomTextColor,
        left: state.roomnameLeft,
        top: state.roomnameTop
      };
    },
    getAppSVGStyle: (state) => {
      return {
        fill: state.SVGAppColor,
      };
    },
    // 'inline' sobald eine Icon-Farbe konfiguriert ist -> Kachel-SVGs werden
    // inline gerendert und ueber currentColor eingefaerbt. Sonst 'legacy':
    // alles (auch SVG) wird wie bisher als background-image gerendert.
    getTileColorMode: (state) => {
      return state.appIconColor || state.activeAppIconColor ? 'inline' : 'legacy';
    },
    getAppStyles: (state, getters) => (isActive) => {
      const inline = getters.getTileColorMode === 'inline';
      if (isActive) {
        return {
          borderColor: state.activeAppBorderColor,
          backgroundColor: state.activeAppBgColor,
          // Im Inline-Modus traegt 'color' die Bildfarbe (currentColor) der SVG;
          // der Titel bekommt seine Farbe separat ueber getAppTitleStyles.
          color: inline ? state.activeAppIconColor : state.activeAppTitleColor,
          borderWidth: '5px',
          height: state.appBarHeight + "vh",
          marginBottom: state.appBarBottom + "vh",
          //fill: state.SVGAppColor,
        };
      }
      return {
        // Der inaktive Rahmen ist BEWUSST transparent, nicht state.appBorderColor.
        //
        // Er ist reiner Platzhalter: die Kacheln tragen ihren 5px-Rahmen jetzt
        // in jedem Zustand (components/Navigation.vue und components/Vod.vue),
        // damit der Titelbalken beim Aktivieren nicht um die Rahmenbreite nach
        // unten springt. Sichtbar werden darf er dabei nicht - inaktiv war er
        // es nie, denn bis hierher war er 0px breit und damit unabhaengig von
        // seiner Farbe unsichtbar.
        //
        // Das gilt auch dann, wenn das Portal ein appBorderColor mitschickt:
        // setCustomizerValues uebernimmt jeden Schluessel der Antwort in den
        // State, und ein bis dahin wirkungsloser Wert soll nicht ploetzlich auf
        // allen Kacheln erscheinen. Wer einen inaktiven Rahmen zeigen will,
        // fuehrt Farbe UND Breite zusammen ein.
        borderColor: 'transparent',
        backgroundColor: state.appBgColor,
        height: state.appBarHeight + "vh",
        marginBottom: state.appBarBottom + "vh",
        color: inline ? state.appIconColor : state.appBarTextColor,
        //fill: state.SVGAppColor,
      };
    },
    getDateStyles(state, getters) {
      var style = {};
      if(state.isShowHeadline) {
        style = {
          textAlign: 'left',
          color: state.dateTextColor,
        };
      } else if(state.isShowDate && state.isShowDateBorder) {
        style = {
          color: state.dateTextColor,
          backgroundColor: state.dateBgColor,
          border: '1px solid',
          borderColor: state.dateBorderColor,
          textAlign: 'center',
        };
      } else if(state.isShowDate) {
        style = {
          color: state.dateTextColor,
          textAlign: 'left',
          fontWeight: '700',
          fontSize: '4.5vh',
          marginTop: '4vh',
        };
      }
      return style;
    },
    getAppTitleStyles: (state) => (isActive) => {
      if (isActive) {
        return {
          color: state.activeAppTitleColor,
        };
      }
      return {
        color: state.appBarTextColor,
      };
    },
    getAppSubtitleStyles: (state) => (isActive) => {
      if (isActive) {
        return {
          color: state.activeAppTitleColor,
        };
      }
      return {
        color: state.appSubtitleColor,
      };
    },
    getWelcomeValues(state) {
      return {
        welcomeMessageColor: state.welcomeMessageColor,
        welcomeDetailColor: state.welcomeDetailColor,
        welcomeDetailActiveColor: state.welcomeDetailActiveColor,
        welcomeDetailActiveBackgroundColor: state.welcomeDetailActiveBackgroundColor,
        welcomeCustomerNameColor: state.welcomeCustomerNameColor,
        welcomeTextColor: state.welcomeTextColor,
        welcomeLang: state.welcomeLang,
      };
    },
    getWelcomeBackground(state) {
      if(state.bgImageWelcomeUrl) {
        return `url(${state.bgImageWelcomeUrl}) top left / cover no-repeat`;
      }
      return state.bgColor;
    },
    getWelcomeStyles(state, getters) {
      var style = {};
      style = {
        color: state.welcomeTextColor,
        backgroundColor: state.dateBgColor,
        border: '1px solid',
        borderColor: state.dateBorderColor,
        textAlign: 'center',
        background: getters.getWelcomeBackground,
      };
      return style;
    },
    getVodValues(state) {
      //TODO: css style <- DB
      return {
        vodMessageColor: state.welcomeMessageColor,
        vodDetailColor: state.welcomeDetailColor,
        vodDetailActiveColor: state.welcomeDetailActiveColor,
        vodDetailActiveBackgroundColor: state.welcomeDetailActiveBackgroundColor,
        vodCustomerNameColor: state.welcomeCustomerNameColor,
        vodTextColor: state.welcomeTextColor,
        vodLang: state.welcomeLang,
      };
    },
    /*
    getVodBackground(state) {
      //vodBgImageUrl
      if(state.bgImageVodUrl) {
        return `url(${state.bgImageVodUrl}) top left / cover no-repeat`;
      }
      return state.bgColor;
    },
    */
    getVodStyles(state, getters) {
      var style = {};
      style = {
        color: state.dateTextColor,
        backgroundColor: state.dateBgColor,
        border: '1px solid',
        borderColor: state.dateBorderColor,
        textAlign: 'center',
        background: getters.getVodBackground,
      };
      return style;
    },
    getLanguage(state) {
      //return state.language;
      if(state.language) {
        return Object.values(state.language).filter((e) => e.show).sort((a, b) => (a.position > b.position ? 1 : -1));
        //console.log("==========GETLANGUAGE", state.language);
        /*return state.language.filter((product) => {
          return product.show
        });*/
      }
    },
  },
};

/*
    "welcomeMessageColor" : "#FFFFFF",
    "welcomeDetailColor" : "#FFFFFF",
    "welcomeDetailActiveColor" : "#FFFFFF",
    "welcomeDetailActiveBackgroundColor" : "#131F26",
    "welcomeCustomerNameColor" : "#0088CC",
    "welcomeTextColor" : "#131F26",
    "bgImageWelcomeUrl" : "https://portal.triax.biz/images/svg/portal.svg",
    "welcomeLang" : null,

    welcomeBgColor


    "vodBgColor" : "#008ea6",
    "vodFooterBorderColor" : "#ffffff",
    "vodButtonColor" : "#008ea6",
    "activeVodButtonColor" : "#ffffff",

    bgImageVodUrl

    "castBgColor" : "#141414",    (Cast-Seite, einfarbig; leer = #141414)
    "castTextColor" : "#f1f1f1",  (Kopfzeile der Cast-Seite; leer = #f1f1f1)
*/



// WEBPACK FOOTER //
// ./src/store/modules/customizer.js